//
// Copyright (c) 2020 Astute Global, Inc.
//

define(["marionette", "./template/kbRoleHistoryModalTemplate.html"], function (
  Marionette,
  KbRoleHistoryModalTemplate,
) {
  "use strict";

  var KbRoleHistoryModalView = {};

  KbRoleHistoryModalView.kbRoleHistoryModalLayout = Marionette.Layout.extend({
    template: KbRoleHistoryModalTemplate,
    regions: {
      kbRoleHistory: "#kbRoleHistory",
    },
    triggers: {
      "click #doneButton": "done",
    },
  });

  return KbRoleHistoryModalView;
});
